var map = {
	"./CurrentAffairs": [
		50650,
		650
	],
	"./CurrentAffairs.json": [
		50650,
		650
	],
	"./EarthAndEnvironment": [
		46811,
		6811
	],
	"./EarthAndEnvironment.json": [
		46811,
		6811
	],
	"./IndiaAndTheWorld": [
		18750,
		8750
	],
	"./IndiaAndTheWorld.json": [
		18750,
		8750
	],
	"./LanguageAndLiterature": [
		20269,
		269
	],
	"./LanguageAndLiterature.json": [
		20269,
		269
	],
	"./LifeSkills": [
		11547,
		1547
	],
	"./LifeSkills.json": [
		11547,
		1547
	],
	"./MathsFun": [
		74039,
		4039
	],
	"./MathsFun.json": [
		74039,
		4039
	],
	"./MeAndMySurroundings": [
		84815,
		4815
	],
	"./MeAndMySurroundings.json": [
		84815,
		4815
	],
	"./PlantsAndAnimals": [
		40839,
		839
	],
	"./PlantsAndAnimals.json": [
		40839,
		839
	],
	"./ScienceAndTechnology": [
		65830,
		5830
	],
	"./ScienceAndTechnology.json": [
		65830,
		5830
	],
	"./Sports": [
		71776,
		1776
	],
	"./Sports.json": [
		71776,
		1776
	],
	"./TransportAndCommunication": [
		86495,
		6495
	],
	"./TransportAndCommunication.json": [
		86495,
		6495
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 13882;
module.exports = webpackAsyncContext;